import React from 'react'
import { FaBell } from "react-icons/fa";


function NotificationBar() {
    const notifications = [
        "New Product Launch!",
        "50% Off This Week!",
        "Trusted by Thousands of Clients!",
        "Expert Installation Services!",
        "Quality Guaranteed!"
    ];
    return (
        <div className="notification-wrapper mt-3">
            <div className="notification-title d-flex align-items-center">
                <FaBell />
            </div>            <div className="notification-marquee">
                <div className="notification-track">
                    {notifications.concat(notifications).map((note, index) => (
                        <span key={index} className="notification-item">
                            {note}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default NotificationBar
